import React, { useState, useEffect } from "react";
import { TODIS_DROPDOWN } from '../../components/Forms';
import { TODIS_DATEPICKER, TODIS_DATEPICKER_INDV } from '../../components/Buttons';
import { AuxiliaryService } from '../../HttpService/AuxiliaryService';
import ExportService from '../../HttpService/ExportService';
import { getLabelById, getRelatedTablesById } from './TranslationParser';
import Swal from 'sweetalert2';
import {
  BsGeoAlt,
  BsGrid,
  BsBuilding,
  BsLayers,
  BsTable,
  BsFullscreen,
  BsSearch,
  BsPlus
} from "react-icons/bs";
import { Row, Col, Badge } from "react-bootstrap";
import style from "./Export.module.scss";
import * as XLSX from "xlsx";
import { VisorExport } from "./VisorExport";
const Export = () => {
  const [type, setType] = useState([]);
  const [regionals, setRegionals] = useState([]);
  const [sectors, setSectors] = useState([]);
  const [filterR, setFilterR] = useState({
    "TENT Category": [],
    "Regional Partner": [],
    "Type": [],
    "Years": null, // Estado inicial como null
    "Sector": [],
    "transportType": [],
  });
  const [filter, setFilter] = useState({});
  const [responseR, setResponse] = useState(false);
  const [tentCategory, setTentCategory] = useState([]);
  //const [layers, setLayers] = useState([]);
  const [attributes, setAttributes] = useState([]);
  const [relatedTables, setRelatedTables] = useState([]);
  const [selectedAttributes, setSelectedAttributes] = useState([]);
  const [tableData, setTableData] = useState([]);
  const [legis, setlegis] = useState(null);
  const [isRelatedTablesOpen, setIsRelatedTablesOpen] = useState(false);
  const tentCategoryMap = {
    4: "Core",
    5: "Comprehensive",
    308: "Core Corridor",
  };
  const regionalPartnerMap = {
    76: "RS", // Serbia
    77: "KO", // Kosovo*
    78: "AL", // Albania
    79: "BA", // Bosnia and Herzegovina
    81: "ME", // Montenegro
    82: "MK", // North Macedonia,
  };

  // Función para alternar el estado de las tablas relacionadas
  const toggleRelatedTables = () => {
    setIsRelatedTablesOpen((prev) => !(prev));
  };

  useEffect(() => {
    // Verificar si se han seleccionado todos los filtros necesarios
    const areFiltersComplete =
      filter.projectType?.length > 0 &&
      filter.sector?.length > 0 &&
      filter.regionalPartner?.length > 0 &&
      filter.tentCategories?.length > 0 &&
      filter.fromDate;

    if (areFiltersComplete) {
      //console.log("Criterios cumplidos, cargando datos...");

      const fetchData = async () => {
        try {
          const filterParams = {
            module: filter.projectType ? parseInt(filter.projectType[0], 10) : null,
            regionalPartner: filter.regionalPartner || [],
            tentCategory: filter.tentCategories || [],
            sector: filter.sector ? parseInt(filter.sector[0], 10) : null,
            year: filter.fromDate || null,
            layers: filter.layers || [],
            relatedTables: filter.relatedTables || [],
            attributes: filter.attributes || [],
          };

          // Primero obtener las tablas relacionadas
          const relatedTablesData = await new ExportService().getRelatedTables(filterParams);
          const formattedTables = relatedTablesData.map((table) => ({ id: table, name: getRelatedTablesById(table) }));
          setRelatedTables(formattedTables);

          // Asegurar que la primera tabla esté seleccionada
          if (formattedTables.length > 0) {
            const firstTable = formattedTables[0];
            const currentTables = filterR["Related Tables"] || [];

            if (!currentTables.some(table => table.id === firstTable.id)) {
              setFilterR(prevState => ({
                ...prevState,
                "Related Tables": [firstTable]
              }));

              setFilter(prevState => ({
                ...prevState,
                relatedTables: [firstTable.id]
              }));
            }

            // Después de asegurar la tabla relacionada, obtener los atributos
            const attributesData = await new ExportService().getAttributes(filterParams);
            console.log("attributesData", attributesData);

            // Asegurar que 'id' sea el primero en la lista
            const sortedAttributes = attributesData.map(attr => ({ id: attr, name: getLabelById(attr)}));
            const idIndex = sortedAttributes.findIndex(attr => attr.name.toLowerCase() === 'id');

            if (idIndex !== -1) {
              const idAttribute = sortedAttributes.splice(idIndex, 1)[0];
              sortedAttributes.unshift(idAttribute); // Mover 'id' al inicio
            }

            setAttributes(sortedAttributes);
          }
        } catch (error) {
          console.error("Error fetching data:", error);
        }
      };

      fetchData();
    } else {
      // Limpiar atributos si no se cumplen los criterios
      setAttributes([]);
    }
  }, [
    filter.projectType,
    filter.sector,
    filter.regionalPartner,
    filter.tentCategories,
    filter.fromDate,
    filter.relatedTables // Agregada esta dependencia
  ]);

  const Toast = Swal.mixin({
    toast: true,
    position: 'top-end',
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: true,
    didOpen: (toast) => {
      toast.addEventListener('mouseenter', Swal.stopTimer);
      toast.addEventListener('mouseleave', Swal.resumeTimer);
    }
  });

  // Función para manejar la selección de fechas
  const handleDate = (value, name) => {
    //console.log("handleDate called with value:", value, "and name:", name);

    // If value is a Date object, extract the year
    const year = value instanceof Date ? value.getFullYear().toString() : value;

    setFilterR((prevState) => ({
      ...prevState,
      [name]: year // Store just the year string
    }));

    if (year) {
      setFilter((prevState) => ({
        ...prevState,
        fromDate: year
      }));
    } else {
      setFilter((prevState) => {
        const newValue = { ...prevState };
        delete newValue["fromDate"];
        return newValue;
      });
    }
  };

  // Función para obtener datos de selección
  const getDataSelect = async () => {
    try {
      const auxiliaries = await new AuxiliaryService("auxData/typeform,regionalpartner,typetransport,tentcategory,regulatoryarea").getAuxiliaries();

      auxiliaries.forEach(item => {
        if (item.txtNameTable === "typeform")
          setType(item.auxtableDetailsDTOList.filter(itm => itm.txtDescription !== "EU Acquis"));
        if (item.txtNameTable === "regionalpartner") {
          let list = item.auxtableDetailsDTOList.sort((a, b) =>
            a.txtDescription.localeCompare(b.txtDescription));
          setRegionals(list);
        }
        if (item.txtNameTable === "typetransport")
          setSectors(item.auxtableDetailsDTOList);
        if (item.txtNameTable === "tentcategory")
          setTentCategory(item.auxtableDetailsDTOList);
      });

      setResponse(true);
    } catch (error) {
      //console.log("error listing selects", error);
    }
  };

  // Función para eliminar todos los filtros
  const removeAllFilterR = () => {
    setFilterR({
      "TENT Category": [],
      "Regional Partner": [],
      "Type": [],
      "Years": null,
      "Sector": [],
      "transportType": [],
      "Related Tables": [],
      "Attributes": [],
      "Layers": [],
    });

    setFilter({});
    setSelectedAttributes([]);
    setAttributes([]);
    //setLayers([]);
    setRelatedTables([]);
    setTableData([]);
    setlegis(null)
    Swal.fire({
      icon: "success",
      title: "Filters removed",
      text: "All filters have been cleared.",
    });
  };

  useEffect(() => {
    getDataSelect();
  }, []);

  const handleSelectS = (value, e, name, id) => {
    if (name === "Type" || name === "Sector") {
      // Sobrescribir cualquier selección previa para "Module" o "Sector"
      setFilterR(prevState => ({
        ...prevState,
        [name]: [{ id: value, name: e.target.text }]
      }));

      setFilter(prevState => ({
        ...prevState,
        [id]: [value]
      }));
    } else if (name === "Related Tables" || name === "Attributes") {
      // Verificar si ya existe este valor en el filtro
      const exists = filterR[name]?.some(item => item.id === value);

      if (!exists) {
        setFilterR(prevState => ({
          ...prevState,
          [name]: [...(prevState[name] || []), { id: value, name: e.target.text }]
        }));

        setFilter(prevState => {
          const newValue = { ...prevState };
          if (!newValue[id]) {
            newValue[id] = [value];
          } else if (!newValue[id].includes(value)) {
            newValue[id].push(value);
          }
          return newValue;
        });
      } else {
        Toast.fire({
          icon: 'warning',
          title: `Filter by ${name} <b>${e.target.text}</b> is already applied`
        });
      }
    } else {
      // Verificar si ya existe este valor en el filtro
      const exists = filterR[name]?.some(item => item.id === value);

      if (!exists) {
        setFilterR(prevState => ({
          ...prevState,
          [name]: [...(prevState[name] || []), { id: value, name: e.target.text }]
        }));

        setFilter(prevState => {
          const newValue = { ...prevState };
          if (!newValue[id]) {
            newValue[id] = [value];
          } else if (!newValue[id].includes(value)) {
            newValue[id].push(value);
          }
          return newValue;
        });
      } else {
        Toast.fire({
          icon: 'warning',
          title: `Filter by ${name} <b>${e.target.text}</b> is already applied`
        });
      }
    }
  };

  // Handle attribute selection
  const handleAttributeToggle = (attributeId) => {
    setSelectedAttributes(prev => {
      // If trying to uncheck 'id', prevent it
      if (attributeId.toLowerCase() === 'id') {
        return prev;
      }

      if (prev.includes(attributeId)) {
        return prev.filter(id => id !== attributeId);
      } else {
        // When adding new attribute, ensure 'id' remains first
        return ['id', ...prev.filter(id => id.toLowerCase() !== 'id'), attributeId];
      }
    });
  };

  const removefilterR = (name, id, value) => {
    setFilterR(prevState => {
      const newValue = { ...prevState };
      if (newValue[name]) {
        newValue[name] = newValue[name].filter(item => item.id !== value);
      }
      return newValue;
    });

    setFilter(prevState => {
      const newValue = { ...prevState };
      if (newValue[id]) {
        newValue[id] = newValue[id].filter(item => item !== value);
        /* if (newValue[id].length === 0) {
          delete newValue[id];
        } */
      }
      return newValue;
    });
  };

  const removeFilterDate = (name) => {
    setFilterR((prevState) => {
      const newValue = { ...prevState };
      newValue[name] = null;
      return newValue;
    });

    setFilter((prevState) => {
      const newValue = { ...prevState };
      delete newValue["fromDate"];
      return newValue;
    });
  };


  // Asegurarse de que la primera tabla esté seleccionada por defecto
  useEffect(() => {
    if (
      Array.isArray(relatedTables) &&
      relatedTables.length > 0 &&
      (!Array.isArray(filterR["Related Tables"]) || filterR["Related Tables"].length === 0)
    ) {
      const firstTable = relatedTables[0];
      setFilterR((prevState) => ({
        ...prevState,
        "Related Tables": [firstTable],
      }));

      setFilter((prevState) => ({
        ...prevState,
        relatedTables: [firstTable.id],
      }));
    }
  }, [relatedTables]);

  // Revalidar la selección de la primera tabla al cambiar filtros relevantes
  useEffect(() => {
    if (
      Array.isArray(relatedTables) &&
      relatedTables.length > 0 &&
      (!Array.isArray(filterR["Related Tables"]) || filterR["Related Tables"].length === 0)
    ) {
      const firstTable = relatedTables[0];
      setFilterR((prevState) => ({
        ...prevState,
        "Related Tables": [firstTable],
      }));

      setFilter((prevState) => ({
        ...prevState,
        relatedTables: [firstTable.id],
      }));
    }
  }, [filter.sector, filter.projectType, filter.regionalPartner, filter.tentCategories, filter.fromDate]);

  // Modificar la función para manejar la selección de tablas relacionadas
  const handleRelatedTableToggle = (e, table) => {
    const isChecked = e.target.checked;

    // Siempre mantener la primera tabla seleccionada
    if (table.id === relatedTables[0]?.id) {
      e.preventDefault(); // Prevenir el cambio de estado del checkbox
      e.target.checked = true; // Mantener el checkbox marcado
      return;
    }

    if (isChecked) {
      setFilterR(prevState => ({
        ...prevState,
        "Related Tables": [...(prevState["Related Tables"] || []), table]
      }));

      setFilter(prevState => ({
        ...prevState,
        relatedTables: [...(prevState.relatedTables || []), table.id]
      }));
    } else {
      setFilterR(prevState => ({
        ...prevState,
        "Related Tables": prevState["Related Tables"].filter(item => item.id !== table.id)
      }));

      setFilter(prevState => ({
        ...prevState,
        relatedTables: prevState.relatedTables.filter(id => id !== table.id)
      }));
    }
  };


  // Función para seleccionar todos los atributos
  const handleSelectAllAttributes = () => {
    if (selectedAttributes.length === attributes.length) {
      // If deselecting all, still keep 'id' selected
      const idAttribute = attributes.find(attr => attr.id.toLowerCase() === 'id');
      setSelectedAttributes(idAttribute ? [idAttribute.id] : []);
    } else {
      // When selecting all, ensure 'id' is first
      const allAttributeIds = attributes.map(attr => attr.id);
      const idIndex = allAttributeIds.findIndex(id => id.toLowerCase() === 'id');
      if (idIndex !== -1) {
        const idAttribute = allAttributeIds.splice(idIndex, 1)[0];
        allAttributeIds.unshift(idAttribute);
      }
      setSelectedAttributes(allAttributeIds);
    }
  };

  const handleSubmit = async () => {
    try {
      // Transformar los datos del filtro
      const filterParams = {
        module: filter.projectType ? parseInt(filter.projectType[0], 10) : null, // Integer
        regionalPartner: filter.regionalPartner
          ? filter.regionalPartner.map((id) => regionalPartnerMap[id.toString()])
          : [], // List<String> (country codes)
        tentCategory: filter.tentCategories
          ? filter.tentCategories.map((id) => tentCategoryMap[id.toString()])
          : [], // List<String> (Core/Comprehensive)
        sector: filter.sector ? parseInt(filter.sector[0], 10) : null, // Integer
        year: filter.fromDate || null, // String
        layers: filter.layers || [], // List<String>
        relatedTables: filter.relatedTables || [], // List<String>
        attributes: selectedAttributes.map(toCamelCase) || [], // Convertir atributos seleccionados a camelCase
      };

      //console.log("Sending filters to backend:", filterParams);
      const response = await new ExportService().getRelatedAttributes(filterParams);
      console.log("Response received from backend:", response);

      // Verificar si hay datos en la respuesta
      if (!response || response.length <= 1) {
        Swal.fire({
          icon: "info",
          title: "No Data Found",
          text: "No data available for the selected filters. Please try different filter combinations.",
        });
        setTableData([]); // Limpiar la tabla
        setlegis(null); // Limpiar el mapa
        return;
      }

      setlegis(response);

      const filteredData = response.slice(1);

      // Mapear los datos para que coincidan con los atributos seleccionados
      const mappedData = filteredData.map((item) => {
        const mappedItem = {};

        // Buscar atributos seleccionados en el nivel principal y en tablas auxiliares
        selectedAttributes.map(toCamelCase).forEach((attr) => {
          if (item[attr] !== undefined) {
            // Si el atributo está en el nivel principal
            mappedItem[attr] = item[attr];
          } else {
            // Buscar en tablas auxiliares
            for (const key in item) {
              if (typeof item[key] === "object" && item[key] !== null && item[key][attr] !== undefined) {
                mappedItem[attr] = item[key][attr];
                break;
              }
            }
          }
        });

        return mappedItem;
      });

      setTableData(mappedData);

    } catch (error) {
      console.error("Error fetching data from backend:", error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "An error occurred while fetching the data. Please try again.",
      });
    }
  };

  const toCamelCase = (str) => {
    return str.replace(/_([a-z])/g, (_, letter) => letter.toUpperCase());
  };

  const getExportFileName = ({ module = "Export" }) => {
    const now = new Date();
    const pad = (n) => n.toString().padStart(2, '0');

    const date = `${now.getFullYear()}${pad(now.getMonth() + 1)}${pad(now.getDate())}`;
    const time = `${pad(now.getHours())}${pad(now.getMinutes())}${pad(now.getSeconds())}`;

    return `${module}_${date}_${time}`;
  };

  const exportToCSV = () => {
    if (tableData.length === 0) {
      alert("No data available to export.");
      return;
    }

    // Generar encabezados a partir de los atributos seleccionados
    const headers = selectedAttributes.map(toCamelCase).join(",");

    // Generar filas de datos
    const rows = tableData.map((row) =>
      selectedAttributes
        .map(toCamelCase)
        .map((attr) => {
          const value = row[attr];
          // Escapar comas y comillas en los valores
          return typeof value === "string" ? `"${value.replace(/"/g, '""')}"` : value || "";
        })
        .join(",")
    );

    // Combinar encabezados y filas
    const csvContent = [headers, ...rows].join("\n");

    // Crear un archivo Blob con el contenido CSV
    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });

    // Crear un enlace para descargar el archivo
    const link = document.createElement("a");
    const url = URL.createObjectURL(blob);

    // Usar la función para obtener el nombre del archivo
    link.setAttribute("href", url);
    link.setAttribute("download", getExportFileName({ module: "Export" }) + ".csv");
    link.style.visibility = "hidden";

    // Agregar el enlace al DOM y hacer clic en él
    document.body.appendChild(link);
    link.click();

    // Limpiar el enlace del DOM
    document.body.removeChild(link);
  };

  const exportToXLSX = () => {
    if (tableData.length === 0) {
      alert("No data available to export.");
      return;
    }

    // Crear una hoja de trabajo (worksheet) a partir de los datos
    const headers = selectedAttributes.map(toCamelCase);
    const rows = tableData.map((row) =>
      selectedAttributes.map(toCamelCase).map((attr) => row[attr] || "")
    );

    const worksheetData = [headers, ...rows];
    const worksheet = XLSX.utils.aoa_to_sheet(worksheetData);

    // Crear un libro de trabajo (workbook) y agregar la hoja
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Data");

    // Exportar el archivo Excel usando la función para obtener el nombre del archivo
    XLSX.writeFile(workbook, getExportFileName({ module: "Export" }) + ".xlsx");
  };

  const areFiltersComplete = () => {
    return (
      filter.projectType?.length > 0 &&
      filter.sector?.length > 0 &&
      filter.fromDate && // Verifica que el año esté seleccionado
      filter.regionalPartner?.length > 0 &&
      filter.tentCategories?.length > 0 &&
      filter.relatedTables?.length > 0 &&
      selectedAttributes.length > 0
    );
  };

  return (
    <div className={style.container}>
      {/* Filter Section */}
      <div className={style.filterSection}>
        <div className={style.filterGroup}>
          <div className={style.filterDropdown}>
            <TODIS_DROPDOWN
              title="Module"
              handleSelect={(e, evt) => handleSelectS(e, evt, "Type", "projectType")}
              response={responseR}
              items={type}
              icon={BsGrid}
              drop={'end'}
              menuStyle={{ maxWidth: '200px', overflow: 'auto', whiteSpace: 'nowrap' }}
            />
          </div>

          <div className={style.filterDropdown}>
            <TODIS_DROPDOWN
              title="Regional Partner"
              handleSelect={(e, evt) => handleSelectS(e, evt, "Regional Partner", "regionalPartner")}
              response={responseR}
              items={regionals}
              icon={BsGeoAlt}
              drop={'down'}
            />
          </div>

          <div className={style.filterDropdown}>
            <TODIS_DROPDOWN
              title="TEN-T Category"
              handleSelect={(e, evt) => handleSelectS(e, evt, "TENT Category", "tentCategories")}
              response={responseR}
              items={tentCategory}
              drop={'down'}
            />
          </div>

          <div className={style.filterDropdown}>
            <TODIS_DROPDOWN
              title="Sector"
              handleSelect={(e, evt) => handleSelectS(e, evt, "Sector", "sector")}
              response={responseR}
              // Filtrar las opciones para excluir "Railway Border Crossing" y "Roads Border Crossing"
              items={sectors.filter(
                (sector) =>
                  sector.txtDescription !== "Roads Border crossing" &&
                  sector.txtDescription !== "Railways Border Crossings"
              )}
              icon={BsBuilding}
              drop={'down'}
            />
          </div>

          <div className={style.filterDropdown}>
            <TODIS_DATEPICKER_INDV
              value={filterR["Years"] || ''} // Asegurarse de que siempre sea un string
              handleDate={(value) => handleDate(value, "Years")}
              name="Years"
              onlyYearPicker={true}
              containerStyle={{ width: "100%" }}
            />
          </div>

          {/* Related Tables Dropdown */}
          {relatedTables.length > 0 && (
            <div className={style.filterDropdown}>
              <div
                className={style.dropdown}
                onMouseEnter={() => setIsRelatedTablesOpen(true)}
                onMouseLeave={() => setIsRelatedTablesOpen(false)}
              >
                <button style={{
                  backgroundColor: "#E3F2FD",
                  borderColor: "#E3F2FD",
                  fontSize: "11px",
                  color: "#004494",
                  padding: "0.7rem 1rem",
                  borderRadius: "12px",
                  letterSpacing: '1px',
                  textAlign: "left",
                  width: "100%"
                }} className={style.dropdownButton}>
                  Related Tables <BsTable />
                </button>
                {isRelatedTablesOpen && (
                  <div className={style.relatedTablesMenu}>
                    {relatedTables.map((table) => (
                      <div key={table.id} className={style.relatedTableItem}>
                        <input
                          type="checkbox"
                          id={`relatedTable-${table.id}`}
                          checked={filterR["Related Tables"]?.some((item) => item.id === table.id)}
                          onChange={(e) => handleRelatedTableToggle(e, table)}
                          disabled={table.id === relatedTables[0]?.id} // Deshabilitar la primera tabla
                        />
                        <label htmlFor={`relatedTable-${table.id}`}>{table.name}</label>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </div>
          )}

          {/* Attributes Dropdown */}
          {attributes.length > 0 && (
            <div className={style.filterDropdown}>
              <div className={style.attributesDropdown}>
                <button style={{
                  backgroundColor: "#E3F2FD",
                  borderColor: "#E3F2FD",
                  fontSize: "11px",
                  color: "#004494",
                  padding: "0.7rem 1rem",
                  borderRadius: "12px",
                  letterSpacing: '1px',
                  textAlign: "left",
                  width: "100%"
                }} className={style.attributesButton}>
                  Attributes <span>▼</span>
                </button>
                <div
                  className={style.attributesMenu}
                  style={{
                    maxHeight: '200px',
                    overflowY: 'auto',
                    overflowX: 'hidden',
                    padding: '10px',
                    border: '1px solid #cfd8e3',
                    borderRadius: '4px',
                    backgroundColor: '#fff',
                    position: 'absolute',
                    zIndex: 1000,
                    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
                  }}
                >
                  <button
                    className={style.selectAllButton}
                    onClick={handleSelectAllAttributes}
                  >
                    {selectedAttributes.length === attributes.length ? 'Deselect All' : 'Select All'}
                  </button>
                  {attributes.map((attr) => (
                    <div key={attr.id} className={style.attributeItem}>
                      <input
                        type="checkbox"
                        id={`attr-${attr.id}`}
                        checked={selectedAttributes.includes(attr.id)}
                        onChange={() => handleAttributeToggle(attr.id)}
                      />
                      <label htmlFor={`attr-${attr.id}`}>{attr.name}</label>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          )}

          <div className={style.filterDropdown}>
            <button
              className={style.submitButton}
              onClick={() => {
                //console.log("Current filter state:", filter);
                if (areFiltersComplete()) {
                  handleSubmit();
                } else {
                  Swal.fire({
                    icon: "warning",
                    title: "Incomplete Filters",
                    text: "Please fill in all the required filters before submitting.",
                  });
                }
              }}
              disabled={!areFiltersComplete()} // Deshabilitar si los filtros no están completos
            >
              Submit
            </button>
          </div>
        </div>
      </div>

      {/* Applied Filters Display */}
      {(filterR["Regional Partner"]?.length > 0 ||
        filterR["Type"]?.length > 0 ||
        filterR["Sector"]?.length > 0 ||
        filterR["transportType"]?.length > 0 ||
        filterR["TENT Category"]?.length > 0 ||
        (filterR["Years"] != null)) && (
          <div className={style.appliedFilters}>
            <Row className="mb-2 mt-2" style={{ gap: '10px 0' }}>
              <Col lg={3} style={{ width: 'auto' }}>
                <h6 style={{ fontSize: "0.9rem", cursor: "pointer" }}>
                  <span onClick={() => removeAllFilterR()}>
                    <span className={style.removeFilterIcon}>×</span> Remove All Filters
                  </span>
                </h6>
              </Col>
              <Col lg={12} className="ps-4">
                <Row className="float-start">
                  <Col lg={2} style={{ width: 'auto' }}>
                    <h6>
                      Type:
                      {
                        filterR["Type"].length !== 0 ?
                          filterR["Type"].map((item, index) => (
                            <Badge className={style.bgFilter} key={index}>
                              <span className={style.cursorPointer} onClick={() => removefilterR("Type", "projectType", item.id)}>
                                <span className={style.removeIcon}>×</span>
                              </span> {item.name}
                            </Badge>
                          ))
                          : <Badge className={style.bgFilter}><span className={style.checkIcon}>✓</span> No Project Type Selected</Badge>
                      }
                    </h6>
                  </Col>
                  <Col lg={2} style={{ width: 'auto' }}>
                    <h6>
                      Regional Partner:
                      {
                        filterR["Regional Partner"].length !== 0 ?
                          filterR["Regional Partner"].map((item, index) => (
                            <Badge className={style.bgFilter} key={index}>
                              <span className={style.cursorPointer} onClick={() => removefilterR("Regional Partner", "regionalPartner", item.id)}>
                                <span className={style.removeIcon}>×</span>
                              </span> {item.name}
                            </Badge>
                          ))
                          : <Badge className={style.bgFilter}><span className={style.checkIcon}>✓</span> No Regional Partner Selected</Badge>
                      }
                    </h6>
                  </Col>
                  <Col lg={2} style={{ width: 'auto' }}>
                    <h6>
                      TENT Category:
                      {
                        filterR["TENT Category"].length !== 0 ?
                          filterR["TENT Category"].map((item, index) => (
                            <Badge className={style.bgFilter} key={index}>
                              <span className={style.cursorPointer} onClick={() => removefilterR("TENT Category", "tentCategories", item.id)}>
                                <span className={style.removeIcon}>×</span>
                              </span> {item.name}
                            </Badge>
                          ))
                          : <Badge className={style.bgFilter}><span className={style.checkIcon}>✓</span> No TENT Category Selected</Badge>
                      }
                    </h6>
                  </Col>
                  <Col lg={2} style={{ width: 'auto' }}>
                    <h6 style={{ fontSize: "0.9rem" }}>
                      Sector:
                      {
                        filterR["Sector"].length !== 0 ?
                          filterR["Sector"].map((item, index) => (
                            <Badge className={style.bgFilter} key={index}>
                              <span className={style.cursorPointer} onClick={() => removefilterR("Sector", "sectors", item.id)}>
                                <span className={style.removeIcon}>×</span>
                              </span> {item.name}
                            </Badge>
                          ))
                          : <Badge className={style.bgFilter}><span className={style.checkIcon}>✓</span> No Sector Selected</Badge>
                      }
                    </h6>
                  </Col>
                  <Col lg={2} style={{ width: 'auto' }} className="ps-0">
                    <h6 style={{ fontSize: "0.9rem" }}>
                      Years:
                      {
                        filterR["Years"] != null ?
                          <Badge className={style.bgFilter}>
                            <span className={style.cursorPointer} onClick={() => removeFilterDate("Years")}>
                              <span className={style.removeIcon}>×</span>
                            </span> {filterR["Years"]}
                          </Badge>
                          : <Badge className={style.bgFilter}><span className={style.checkIcon}>✓</span> No Year Selected</Badge>
                      }
                    </h6>
                  </Col>
                </Row>
              </Col>
            </Row>
          </div>
        )}

      {/* Main Content Area */}
      <div className={style.contentSection}>
        {/* Left Table Section */}
        <div className={style.tableSection}>
          <div className={style.tableContainer} style={{ overflowX: "auto" }}>
            <table className={style.table}>
              <thead>
                <tr>
                  {selectedAttributes.map(toCamelCase).map((attr) => (
                    <th key={attr}>{attr}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {tableData.map((row, index) => (
                  <tr key={index}>
                    {selectedAttributes.map(toCamelCase).map((attr, idx) => (
                      <td key={idx}>
                        {typeof row[attr] === "object" && row[attr] !== null
                          ? JSON.stringify(row[attr]) // Convertir objetos a cadenas JSON
                          : row[attr]}
                      </td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <div className={style.exportOptions}>
            <div className={style.exportButtonGroup}>
              <button
                className={style.exportBtn}
                onClick={exportToCSV}
                disabled={tableData.length === 0}
                style={tableData.length === 0 ? { backgroundColor: "#e0e0e0", color: "#888", cursor: "not-allowed" } : {}}
              >
                Export to CSV
              </button>
              <button
                className={style.exportBtn}
                onClick={exportToXLSX}
                disabled={tableData.length === 0}
                style={tableData.length === 0 ? { backgroundColor: "#e0e0e0", color: "#888", cursor: "not-allowed" } : {}}
              >
                Export to XLSX
              </button>
            </div>
          </div>
        </div>

        {/* Right Map Section */}
        <div className={style.mapSection}>
          <div className={style.mapContent}>
            <div className={style.mapView}>
              <VisorExport title={"Map"} dataDashboard={legis} show={true} />
            </div>
            <div className={style.mapControls}>
              <div >
                <span>100km</span>
                <div className={style.scaleBar}></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Export;